import ReviewPatientLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/ReviewPatient'
import React from 'react'

const ReviewPatient = () => <ReviewPatientLayout />

export default ReviewPatient
